import React, { createContext, useReducer } from 'react';

const initialState = {
    activeMomentProgress: 0,
    progressBarDarkThemeEnabled: false,
    overview: false,
    'overview-home': false,
    'overview-incar': false,
    lookaround: false,
    hotspots: false,
    exterior: false,
    comfort: false,
    handling: false,
    propilot: false,
    parkassistactive: false,
    remoteparking: false,
};

const actionStrings = {
    activeMomentProgress: 'SET_ACTIVE_MOMENT_PROGRESS',
    progressBarDarkThemeEnabled: 'SET_PROGRESS_BAR_DARK_THEME',
    overview: 'SET_CONNECTIVITY_OVERVIEW_VISITED',
    'overview-home': 'SET_CONNECTIVITY_IN_HOME_VISITED',
    'overview-incar': 'SET_CONNECTIVITY_IN_CAR_VISITED',
    lookaround: 'SET_DESIGN_HEADS_UP_VISITED',
    hotspots: 'SET_DESIGN_INTERIOR_VISITED',
    exterior: 'SET_DESIGN_EXTERIOR_VISITED',
    comfort: 'SET_PERFORMANCE_COMFORT_VISITED',
    handling: 'SET_PERFORMANCE_HANDLING_VISITED',
    propilot: 'SET_ASSIST_PRO_PILOT_VISITED',
    parkassistactive: 'SET_ASSIST_PARKING_VISITED',
    remoteparking: 'SET_REMOTE_PARKING_VISITED',
};

const MomentStateContext = createContext({ state: initialState });
const { Provider } = MomentStateContext;

const getKeyByValue = (object, value) => Object.keys(object).find((key) => object[key] === value);

const MomentStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer((updatedState, action) => {
        const newState = { ...updatedState };
        const actionKey = getKeyByValue(actionStrings, action.type);

        switch (action.type) {
            case actionStrings.activeMomentProgress:
                newState.activeMomentProgress = Math.ceil(action.payload || 0);
                break;

            case actionStrings.progressBarDarkThemeEnabled:
                newState.progressBarDarkThemeEnabled = action.payload;
                break;

            case actionStrings[actionKey]:
                newState[actionKey] = true;
                break;

            default:
                throw new Error();
        }

        return newState;
    }, initialState);

    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { actionStrings, MomentStateContext, MomentStateProvider };
